import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SubscriptionStatusTab.css';
import ConfirmationModal from './ConfirmationModal';

const API_URL = process.env.REACT_APP_API_URL || '';

function SubscriptionStatusTab() {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, status: null });

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/subscription-status`);
      setStatuses(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке статусов подписок: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (status) => {
    setDeleteModal({ isOpen: true, status });
  };

  const handleDeleteConfirm = async () => {
    if (!deleteModal.status) return;

    try {
      await axios.delete(`${API_URL}/api/subscription-status/${deleteModal.status.id}`);
      setDeleteModal({ isOpen: false, status: null });
      fetchStatuses();
    } catch (err) {
      setError('Ошибка при удалении статуса подписки: ' + (err.response?.data?.detail || err.message));
      setDeleteModal({ isOpen: false, status: null });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ isOpen: false, status: null });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      // Форматируем дату в формате ДД.ММ.ГГГГ ЧЧ:ММ (МСК)
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    } catch (e) {
      return dateString;
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="subscription-status-tab">
      <div className="tab-header">
        <h3>Статусы подписок пользователей</h3>
        <button className="btn btn-secondary" onClick={fetchStatuses} title="Обновить">
          🔄 Обновить
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Telegram ID</th>
              <th>Подписка</th>
              <th>Тариф</th>
              <th>Дата начала</th>
              <th>Дата окончания</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {statuses.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state">
                  Нет активных статусов подписок.
                </td>
              </tr>
            ) : (
              statuses.map((status) => (
                <tr key={status.id}>
                  <td>{status.id}</td>
                  <td>{status.telegram_id}</td>
                  <td>
                    {status.subscription_name || `ID: ${status.subscription_id}`}
                  </td>
                  <td>
                    {status.tariff_periods && status.tariff_periods.length > 0
                      ? status.tariff_periods.map((p, idx) => (
                          <span key={idx} className="tariff-period">
                            {p.period} ({p.price}₽)
                          </span>
                        ))
                      : `ID: ${status.tariff_id}`}
                  </td>
                  <td>{formatDate(status.start_date)}</td>
                  <td>
                    <span className={new Date(status.end_date) < new Date() ? 'expired' : 'active'}>
                      {formatDate(status.end_date)}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDeleteClick(status)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ConfirmationModal
        isOpen={deleteModal.isOpen}
        title="Удаление статуса подписки"
        message={`Вы уверены, что хотите удалить статус подписки для пользователя с Telegram ID ${deleteModal.status?.telegram_id}?\n\nЭто действие нельзя отменить.`}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        confirmText="Удалить"
        cancelText="Отмена"
        confirmButtonType="danger"
      />
    </div>
  );
}

export default SubscriptionStatusTab;

